import angular from 'angular';

import HealthcarebookResponsiveComponent from './responsive.component';

export default angular.module('healthcarebookResponsive', [])
    .component('healthcarebookResponsiveComponent', HealthcarebookResponsiveComponent)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/responsive/responsive.module.js
// module id = 345
// module chunks = 0